import React from "react"
import { CustomCTA } from "../CustomCTA"

import { ContainerInternalWSYSIWG } from "./style"
import WSYSIWGImage from "../../images/WSYSIWGImage.png"
import StepByStep from "../StepByStep/StepByStep"
import { Checklist } from "../Checklist"

const allData = [
  {
    label: "Create a list of possible places to live in Canberra.",
    tip:
      "<span>Tip:</span> Talk to friends and relatives already living here and do some online research",
  },
  { label: "Develop a budget for when you move", tip: "" },
  {
    label: "Find out more about <a href='/'>job opportunities</a> in Canberra",
    tip: "",
  },
]

const InternalWSYSIWG = ({ checklist, stepByStep, content,other }) => {
  return (
    <ContainerInternalWSYSIWG other={other}>
      {checklist ? (
        <>
          {" "}
          <p>
            Before moving to Australia there's lots to think about and plan. Use
            this checklist to help you prepare for your move to Australia.
          </p>
          <hr />
          <h3>Do your research</h3>
          <Checklist data={allData} />
          <h3>Apply for your visas</h3>
          <Checklist data={allData} />
          <h3>Prepare to move out</h3>
          <Checklist data={allData} />
        </>
      ) : stepByStep ? (
        <>
          <p>
            Migrating to a new place is a big step to take, but thankfully
            you're not alone. The information here will help you better
            understand what you need to do and when.
          </p>
          <h2>Move to Canberra in 5 steps</h2>
          <p>
            There has never been a better time to move to Canberra. Follow these
            five key steps below to start your journey.
          </p>
          <StepByStep />
          <CustomCTA content={content} />
          <CustomCTA reverse />
          <CustomCTA />
        </>
      ) : (
        <>{content}</>
      )}
    </ContainerInternalWSYSIWG>
  )
}

export default InternalWSYSIWG
